import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28.876",
  height: "16.559",
  viewBox: "0 0 28.876 16.559"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_546",
  "data-name": "Path 546",
  d: "M1071.343,445.923l12.317,12.317,12.317-12.317",
  transform: "translate(-1069.222 -443.802)",
  fill: "none",
  stroke: "#b52ac9",
  "stroke-linecap": "round",
  "stroke-width": "3"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}